import { useAuthStore, Toasts } from '@sentinel/web-core';
import { Outlet } from '@tanstack/react-router';
import { useRealtime } from '@/core/realtime/use-realtime';
import { AlarmBar } from './AlarmBar';
import { ModuleRail, Nav } from './nav/Nav';
import { OrganizationNotice } from './OrganizationNotice';
import { StatusBar } from './StatusBar';
import { Topbar } from './topbar/Topbar';

/** The authenticated shell: topbar, L4 band, navigation, module area, status bar, toasts. */
export function AppShell() {
  useRealtime();
  const me = useAuthStore((s) => s.me);
  const inOrganization = me?.organization !== null && me?.organization !== undefined;
  return (
    <div className="shell">
      <Topbar />
      {inOrganization ? <AlarmBar /> : null}
      <OrganizationNotice />
      {inOrganization ? <ModuleRail /> : null}
      <div className="body">
        {inOrganization ? <Nav /> : null}
        <main
          className="area"
          data-scroll-restoration-id="main"
          style={inOrganization ? undefined : { gridColumn: '1 / -1' }}
        >
          <Outlet />
        </main>
      </div>
      <StatusBar />
      <Toasts />
    </div>
  );
}
